import { render, staticRenderFns } from "./SerahTerimaGadai.vue?vue&type=template&id=17c905a6&"
import script from "./SerahTerimaGadai.vue?vue&type=script&lang=js&"
export * from "./SerahTerimaGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports